import { render, staticRenderFns } from "./admin-user-main.vue?vue&type=template&id=04665fa1&"
import script from "./admin-user-main.vue?vue&type=script&lang=js&"
export * from "./admin-user-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports